/*
 * --------------------------------------
 * Copyright (c) 2020 BetterCapital.US
 * --------------------------------------
 */
import React from "react";

import zillowLogo from "../../../img/zillow.png";

export default () => (
  <div className="d-flex p-4">
    <div className="w-25 my-auto">
      <a href="https://zillow.com" target="_blank" rel="noopener noreferrer">
        <img alt="Real Estate on Zillow" src={zillowLogo} />
      </a>
    </div>
    <div className="pl-3">
      <a
        href="https://zillow.com"
        target="_blank"
        rel="noopener noreferrer"
        className="font-weight-bold d-flex align-items-center d-flex"
      >
        <div className="font-size-sm">
          Provided via the Zillow Public Records API
        </div>
      </a>
      <p className="mb-0 font-size-sm text-second opacity-7">
        Zillow Data © Zillow, Inc., 2006-2019.
        <br />
        Use is subject to{" "}
        <a
          href="https://www.zillow.com/corp/Terms.htm"
          target="_blank"
          rel="noopener noreferrer"
        >
          Terms of Use
        </a>
      </p>
    </div>
  </div>
);
